import { CaseSettings } from '../domain/case/CaseDomains';
import RoleHelper from '../RoleHelper';
import MessageUtil from './MessageUtil';
import LanguageUtil from './LanguageUtil';
import { CaseActionMenu } from './CasePermissionUtil';

export const BULK_CLOSE_NOT_PERMITTED_ERROR = 'BULK_CLOSE_NOT_PERMITTED';
export const ACTION_NOT_PERMITTED_ERROR = 'ACTION_NOT_PERMITTED';
export const CHAT_WRITE_NOT_PERMITTED_ERROR = 'CHAT_WRITE_NOT_PERMITTED';

function hasCasesBulkClosePermission(
  caseSettings?: CaseSettings | null,
  menu: CaseActionMenu = 'Cases',
): boolean {
  if (caseSettings == undefined || caseSettings == null) {
    return false;
  }
  RoleHelper.setCurrentAccess(caseSettings);
  const canEdit: boolean = RoleHelper.canEdit(menu);
  RoleHelper.clearCurrentAccess();
  return canEdit;
}

export function hasCasesActionPermission(): boolean {
  return RoleHelper.hasGlobalMenuEdit('Action');
}

export function hasCasesChatWritePermission(): boolean {
  return RoleHelper.canEdit('Cases');
}

function isBulkCloseRestrictedForUser(
  username: string,
  caseSettings: Pick<CaseSettings, 'bulkCloseRestrictedUsers'> | undefined | null,
): boolean {
  const restrictedUsers: string[] | undefined = caseSettings?.bulkCloseRestrictedUsers;
  if (restrictedUsers == undefined || restrictedUsers.length === 0) {
    return false;
  }
  return restrictedUsers.includes(username);
}

export function canPerformBulkClose(
  username: string,
  caseSettings: CaseSettings | undefined | null,
  menu: CaseActionMenu = 'Cases',
): boolean {
  if (!hasCasesBulkClosePermission(caseSettings, menu)) {
    return false;
  }
  return !isBulkCloseRestrictedForUser(username, caseSettings);
}

export function notifyActionNotPermitted(): void {
  MessageUtil.error({
    summary: LanguageUtil.get({ id: 'common.label.error', defaultMessage: 'Error' }),
    detail: LanguageUtil.get({
      id: 'messages.error.actionNotPermitted',
      defaultMessage: 'You do not have permission to perform action operations.',
    }),
  });
}

export function notifyChatWriteNotPermitted(): void {
  MessageUtil.error({
    summary: LanguageUtil.get({ id: 'common.label.error', defaultMessage: 'Error' }),
    detail: LanguageUtil.get({
      id: 'messages.error.chatWriteNotPermitted',
      defaultMessage: 'You do not have permission to send chat messages.',
    }),
  });
}

export function assertCanPerformAction(): boolean {
  if (!hasCasesActionPermission()) {
    notifyActionNotPermitted();
    return false;
  }
  return true;
}

export function assertCanWriteChat(): boolean {
  if (!hasCasesChatWritePermission()) {
    notifyChatWriteNotPermitted();
    return false;
  }
  return true;
}
